import { render, staticRenderFns } from "./dynamicFormWithFlows.vue?vue&type=template&id=36f8d0d3&scoped=true&"
import script from "./dynamicFormWithFlows.vue?vue&type=script&lang=js&"
export * from "./dynamicFormWithFlows.vue?vue&type=script&lang=js&"
import style0 from "./dynamicFormWithFlows.vue?vue&type=style&index=0&id=36f8d0d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f8d0d3",
  null
  
)

export default component.exports